import React from 'react';

interface LabelProps {
  title: string;
  // eslint-disable-next-line react/no-unused-prop-types
  dropdownLabels: Record<string, string[]>;
}

export const TableLabel = ({ title }: LabelProps) => {
  return (
    <div className="table-header-width">
      <span>{title}</span>
      <span className="arrow-down" />
    </div>
  );
};
